interface TextInputProps {
  id: string;
  type: string;
  label?: string;
  labelColour?: string;
  ariaLabel?: string;
  textColour?: string;
  bgColour?: string;
  borderClass?: string;
  placeholderColour?: string;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  children?: React.ReactNode;
  showLabel?: boolean;
  onChange?: (e: any) => void;
  disabled?: boolean;
  small?: string | null;
  widthClass?: string;
  value?: string;
  maxLength?: number | undefined;
  rounded?: string;
  error?: string | null;
  onBlur?: (e: any) => void;
}

export default function TextInput({
  id,
  type,
  label,
  labelColour = "dark-grey",
  ariaLabel = "",
  textColour = "dark-grey",
  bgColour = "light dark:bg-black-light",
  borderClass = "border-none",
  placeholderColour = "dark-grey/50",
  placeholder = "",
  autoComplete = "",
  required = true,
  children,
  showLabel = false,
  onChange = () => { },
  disabled = false,
  small = null,
  widthClass = "w-full",
  value = "",
  maxLength = undefined,
  rounded = "full",
  error = null,
  onBlur = () => { },
}: TextInputProps) {
  // "orange" is this app's error colour (see addAlert), and it is one of the few
  // colours the Tailwind safelist covers — "red-*" would be purged from the build.
  const appliedBorderClass = error ? "border-2 border-orange" : borderClass;
  const errorId = `${id}-error`;
  return (
    <div className={widthClass}>
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-bold text-${labelColour}`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`hidden block text-left text-sm font-bold text-${labelColour}`}
        />
      )}
      {disabled ? (
        <input
          id={id}
          type={type}
          className={`block w-full rounded-${rounded} bg-${bgColour} py-1.5 pl-3 pr-10 text-base text-${placeholderColour} placeholder:text-${placeholderColour} ${appliedBorderClass} outline-none placeholder:text-${placeholderColour} focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-dark-grey sm:pr-9 text-xs sm:text-sm/6`}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          required={required}
          onChange={onChange}
          disabled
          value={value}
          maxLength={maxLength}
        >
          {children}
        </input>
      ) : (
        <input
          id={id}
          type={type}
          className={`block w-full rounded-${rounded} bg-${bgColour} py-1.5 pl-3 pr-10 text-base text-${textColour} placeholder:text-${placeholderColour} ${appliedBorderClass} placeholder:text-${placeholderColour} focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-dark-grey sm:pr-9 text-xs sm:text-sm/6`}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          required={required}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          maxLength={maxLength}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
        >
          {children}
        </input>
      )}
      {error ? (
        <p id={errorId} role="alert" className="text-xs text-left text-orange mt-2">
          {error}
        </p>
      ) : (
        small !== null && (
          <p className="text-xs text-left text-secondary/70 mt-2">{small}</p>
        )
      )}
    </div>
  );
}
